(ns portal.role-table.db
  (:require [common.db.table.backend :refer [map->RemoteBackend]]
            [common.db.table.core :refer [register-table]]
            [common.permissions :refer [->summarized-internal-representation]]
            [re-frame.core :as rf]))

(def backend
  (map->RemoteBackend
   {:on-init [:resource.roles/get-all-paginated]
    :on-change [:resource.roles/get-all-paginated]}))

(register-table
 {:namespace :role-table.db
  :value-sub [:role-table.db/all]
  :initial-sort {:column :name :direction :asc}
  :initial-search {:column :name :term ""}
  :initial-page {:size 10 :cursor 0}
  :backend backend})

(rf/reg-sub :role-table.db/all
  :<- [:resource.roles/paginated]
  (fn [roles]
    (update roles :value #(map (fn [role]
                                 (-> role
                                     (assoc :name {:name (:name role)
                                                   :attached-users (:attachedUsers role)})
                                     (update :permissions ->summarized-internal-representation)
                                     (select-keys [:id :name :permissions])))
                               %))))

(rf/reg-event-fx :role-table.db/click-row
  (fn [{:keys [db]} [_ {:keys [id]}]]
    (let [role (->> (get-in db [:resource.roles/paginated :value])
                    (filter #(= id (:id %)))
                    first)]
      {:dispatch [:ocp/open {:id :role/crud
                             :props {:role role}}]})))
